<template>
  <section id="fast-facts">
    <div class="fast-facts-header h-32 flex mb-9" :class="category.slug"></div>
    <div class="flex mb-4 text-center fact-row">
      <div v-if="filteredFacts(TYPE_BORN).length > 0">
        <h5 class="text-lerner-orange">BORN</h5>
        <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_BORN)" v-bind:key="fact.id">
          {{ fact.fact }}
        </div>
      </div>
      <div v-if="filteredFacts(TYPE_DIED).length > 0">
        <h5 class="text-lerner-orange">DIED</h5>
        <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_DIED)" v-bind:key="fact.id">
          {{ fact.fact }}
        </div>
      </div>
      <div v-if="filteredFacts(TYPE_POSITION).length > 0">
        <h5 class="text-lerner-orange">POSITION</h5>
        <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_POSITION)" v-bind:key="fact.id">
          {{ fact.fact }}
        </div>
      </div>
      <div v-if="filteredFacts(TYPE_LEAGUE).length > 0">
        <h5 class="text-lerner-orange">LEAGUE</h5>
        <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_LEAGUE)" v-bind:key="fact.id">
          {{ fact.fact }}
        </div>
      </div>
    </div>
    <div class="fast-facts-banner" :class="category.slug"></div>
    <div class="flex mb-4">
      <div class="offset-lg-1 col-lg-5 col-md-6">
        <div v-if="filteredFacts(TYPE_PROFESSIONAL_HIGHLIGHTS).length > 0">
          <h5 class="text-lerner-orange">PROFESSIONAL HIGHLIGHTS</h5>
          <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_PROFESSIONAL_HIGHLIGHTS)"
               v-bind:key="fact.id">
            {{ fact.fact }}
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-6">
        <div v-if="filteredFacts(TYPE_PERSONAL_HIGHLIGHTS).length > 0">
          <h5 class="text-lerner-orange">PERSONAL HIGHLIGHTS</h5>
          <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_PERSONAL_HIGHLIGHTS)"
               v-bind:key="fact.id">
            {{ fact.fact }}
          </div>
        </div>
        <div v-if="filteredFacts(TYPE_CAREER_HISTORY).length > 0">
          <h5 class="text-lerner-orange">CAREER HISTORY</h5>
          <div class="mb-3 body-7" v-for="fact in filteredFacts(TYPE_CAREER_HISTORY)" v-bind:key="fact.id">
            {{ fact.fact }}
          </div>
        </div>
      </div>
      <div class="hidden lg:block col-1"></div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'FastFacts',
    props: {
      facts: {
        default: null,
        type: Array
      },
      category: {
        default: null,
        type: Object
      }
    },
    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
        TYPE_BORN: 1,
        TYPE_DIED: 2,
        TYPE_POSITION: 3,
        TYPE_LEAGUE: 4,
        TYPE_PROFESSIONAL_HIGHLIGHTS: 5,
        TYPE_PERSONAL_HIGHLIGHTS: 6,
        TYPE_CAREER_HISTORY: 7
      }
    },
    methods: {
      filteredFacts(type) {
        if (this.facts == null) return [];

        return this.facts.filter((fact) => {
          return fact.type === type && fact.active;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fast-facts-header {
    margin: auto;
    background-image: url('../assets/images/62-lrn-spt-prof-fast-facts-350.svg');
    background-repeat: no-repeat;
    background-position: 12% center;

    &.basketball {
      @apply bg-c1-e;
    }

    &.football {
      @apply bg-c2-e;
    }

    &.baseball {
      @apply bg-c3-e;
    }

    &.soccer {
      @apply bg-c4-e;
    }

    &.more-sports {
      @apply bg-c5-e;
    }

    &.olympics {
      @apply bg-c6-e;
    }

    &.hockey {
      @apply bg-c7-e;
    }

    &.tennis {
      @apply bg-c8-e;
    }
  }

  .fast-facts-banner {
    background-position: center;
    background-repeat: no-repeat;
    height: 85px;
    margin-top: 2rem;
    margin-bottom: 3.75rem;

    &.basketball {
      background-image: url('../assets/images/63-lrn-spt-prof-div-1-cat-1-730.svg');
    }

    &.football {
      background-image: url('../assets/images/64-lrn-spt-prof-div-1-cat-2-730.svg');
    }

    &.baseball {
      background-image: url('../assets/images/65-lrn-spt-prof-div-1-cat-3-730.svg');
    }

    &.soccer {
      background-image: url('../assets/images/66-lrn-spt-prof-div-1-cat-4-730.svg');
    }

    &.more-sports {
      background-image: url('../assets/images/67-lrn-spt-prof-div-1-cat-5-730.svg');
    }

    &.olympics {
      background-image: url('../assets/images/olympics-category-fast-facts.svg');
    }

    &.hockey {
      background-image: url('../assets/images/hockey-category-fast-facts.svg');
    }

    &.tennis {
      background-image: url('../assets/images/tennis-category-fast-facts.svg');
    }
  }

  .fact-row {
    margin: auto;

    @media (min-width: config('screens.lg')) {
      flex: 0 0 83.33333%;
      max-width: 83.33333%;
    }

    & > div {
      flex: 1 1 0;
      padding: 0 config('padding.3');
    }
  }
</style>
